import React, { useEffect } from 'react';
import { LuCreditCard } from 'react-icons/lu';
import { FaPaypal } from 'react-icons/fa';

export default function PaymentMethod({
  selectedMethod,
  setSelectedMethod,
  disablePaypal = true,            // ← default: disable PayPal
}) {
  // If PayPal is disabled but currently selected, bump back to card
  useEffect(() => {
    if (disablePaypal && selectedMethod === 'paypal') {
      setSelectedMethod?.('card');
    }
  }, [disablePaypal, selectedMethod, setSelectedMethod]);

  const methods = [
    { name: 'card',   label: 'Pay by Card', icon: <LuCreditCard size={20} /> , disabled: false },
    { name: 'paypal', label: 'Paypal',      icon: <FaPaypal size={20} />     , disabled: !!disablePaypal },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.headline}>Payment Method</div>
      <div style={styles.methodsContainer}>
        {methods.map(({ name, label, icon, disabled }) => {
          const isActive = selectedMethod === name;
          return (
            <div
              key={name}
              role="button"
              aria-pressed={isActive}
              aria-disabled={disabled}
              title={disabled ? 'PayPal is currently unavailable' : undefined}
              onClick={() => { if (!disabled) setSelectedMethod(name); }}
              style={{
                ...styles.method,
                ...(isActive ? styles.active : styles.inactive),
                ...(disabled ? styles.disabled : null),
              }}
            >
              <input
                type="radio"
                checked={isActive}
                readOnly
                disabled={disabled}
                style={styles.radio}
              />
              <div style={styles.icon}>{icon}</div>
              <div style={styles.labelContainer}>
                <div style={styles.label}>{label}</div>
                <div style={styles.subLabel}>
                  {name === 'card' ? 'Credit or debit' : (disabled ? 'Unavailable' : 'PayPal')}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  container: {
    marginBottom: '20px',
    marginLeft: '20px',
    marginRight: '20px',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  headline: {
    fontSize: 12,
    fontWeight: 800,
    marginBottom: 12,
    color: '#6B7280',
    letterSpacing: 0.2,
    textTransform: 'uppercase',
  },
  methodsContainer: {
    display: 'flex',
    gap: '10px',
  },
  method: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #EEF0F2',
    background: '#fff',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease',
  },
  active: {
    border: '1px solid #ddd',
    boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
    opacity: 1,
  },
  inactive: {
    opacity: 0.85,
  },
  disabled: {
    opacity: 0.45,
    cursor: 'not-allowed',
    pointerEvents: 'none',
    filter: 'grayscale(12%)',
  },
  radio: {
    accentColor: '#0B0B0B',
    width: '18px',
    height: '18px',
    marginLeft: -2,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#555',
    marginLeft: -4,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '12px',
    fontWeight: 800,
    color: '#0B0B0B',
  },
  subLabel: {
    fontSize: '12px',
    color: '#6B7280',
    marginTop: 2,
  },
};
